// Package Imports
import { Col, Divider, Row, Image } from 'antd';
import dayjs from 'dayjs';

// Project Imports
import Loading from 'components/loading/loading';
import constants from 'core/constants/Constants';
import WinningsCard from 'pages/contest/contestHistory/winningsCard';
import { EyeOutlined } from '@ant-design/icons';
// import ContestPrizeTable from 'pages/myTask/customDetails/contest/contestPrizeTable';
// import formatPrizeData from 'pages/myTask/customDetails/contest/utils/formatPrizeData';

const ContestHistoryOverview = ({
  contestLoading,
  contestDetails,
  unifiedList,
  unifiedColumnList,
  contestUserDetails,
  contestList,
}) => {
  const contestDetailsSection = (label, value) => (
    <Col xs={12} sm={12} lg={12} className="mb-md">
      <span className="mb-0 text-sm text-neutral-500">{label}</span>
      <div className="text-sm font-medium">{value || '-'}</div>
    </Col>
  );
  const unifiedFile = unifiedList.find(
    (item) => item.value === contestDetails?.unified_id
  )?.label;

  const unifiedColumnFile = unifiedColumnList?.find(
    (item) => item.label === contestDetails?.user_unified_column
  )?.label;

  const contestParameter = unifiedColumnList
    ?.filter((item) => contestDetails?.contest_parameters?.includes(item.label))
    .map((item) => item.label);

  console.log(
    'unifiedList',
    unifiedList,
    contestDetails,
    contestParameter,
    unifiedColumnList
  );
  // const prizeData = formatPrizeData(contestDetails?.contest_prize_data || []);

  if (contestLoading) {
    return <Loading />;
  }

  return (
    <div>
      <h6>Overview</h6>
      {/* <Card> */}
      <Row>
        <Col xs={24} sm={24} lg={24} className="mt-sm mb-md">
          {contestDetails?.contest_cover_image_desktop ? (
            <Image
              src={contestDetails?.contest_cover_image_desktop}
              alt="product_image"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                borderRadius: 4,
                objectFit: 'contain',
              }}
              preview={{
                mask: <EyeOutlined />,
              }}
            />
          ) : null}
        </Col>
      </Row>
      <Row>
        {contestDetailsSection('Contest Name', contestDetails?.contest_name)}
        {contestDetailsSection(
          'Status',
          contestDetails?.contest_is_active ? 'Active' : 'Inactive'
        )}
      </Row>
      <Row>
        {contestDetailsSection(
          'Start Date',
          dayjs(contestDetails?.contest_start_date)?.format(
            constants?.ddmmmmyyyy
          )
        )}
        {contestDetailsSection(
          'End Date',
          dayjs(contestDetails?.contest_end_date)?.format(constants?.ddmmmmyyyy)
        )}
      </Row>
      <Row>
        {contestDetailsSection('Contest Type', contestDetails?.contest_type)}
        {contestDetailsSection(
          'Contest Parameter',
          contestParameter?.join(', ')
        )}
      </Row>
      <Row>
        {contestDetailsSection('Unified File', unifiedFile || '-')}
        {contestDetailsSection('User Unified Column', unifiedColumnFile)}
      </Row>
      <Row>
        {contestDetailsSection(
          'Description',
          contestDetails?.contest_description
        )}
      </Row>
      <Row>
        {contestDetailsSection(
          'Terms & Conditions',
          contestDetails?.terms_conditions
        )}
      </Row>
      {/* </Card> */}
      <Divider dashed />
      {/* <h6>Prize Table</h6>
      <ContestPrizeTable dataSource={prizeData || []} /> */}
      {contestUserDetails?.length > 0 ? (
        <>
          <h6 className="mt-sm">Your Winnings</h6>
          {/* <MyTaskCard /> */}
          <Row gutter={[16, 16]}>
            {contestUserDetails?.map((item) => (
              <Col span={24} key={item.taskId}>
                <WinningsCard record={item} headers={contestList?.headers} />
              </Col>
            ))}
          </Row>
        </>
      ) : null}
    </div>
  );
};

export default ContestHistoryOverview;
